export default __webpack_public_path__ + "static/media/Town-logo-dark.09f1765b.svg";